// extracted by mini-css-extract-plugin
export var dropdownButton = "_1h-0";
export var fullWidthDropdownButton = "_1h-1";
export var icon = "_1h-3";
export var iconPlaceholder = "_1h-2";
export var shortcutContainer = "_1h-4";